import styled from '@emotion/styled';

const Button = styled.button`
  margin: 1em;
  cursor: pointer;
  color: #000;
  border: none;
  font-weight: 600;
  background-color: #F0F0F0;
  font-size: 1.3rem;
  padding: .25rem 1rem;
  text-align: center;
  border-radius: 1rem;
  white-space: no-wrap;
  justify-content: center;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
`;

export default Button;